import { GridSizedViewUtils } from "../utils/GridSizeViewUtils";
import { CellRetrievalUtils } from "../utils/CellRetrievalUtils";

/**
 * @descriptino Handles the mouse move event over a selected cell and draws the drag arrow
 */
export class MouseMoveSelectedCell {
    lastHoveredCell;

    lastHoveredDirection;

    cellRetrieval = new CellRetrievalUtils();

    /**
     * @description Handles the mouse move event over a selected cell
     * @param {*} selectedCellPos
     * @param {*} mousePos
     * @param {*} grid
     */
    mouseMoveHappened(selectedCellPos, mousePos, grid) {
        if (!selectedCellPos) {
            this.resetHover();
            return;
        }
        const cell = this.cellRetrieval.getCell(selectedCellPos, grid);
        if (cell) {
            const gridSizeUtils = new GridSizedViewUtils();
            const direction = gridSizeUtils.getMouseDirectionFromTarget(mousePos, null, cell) || gridSizeUtils.getMouseDirectionInsideTarget(mousePos, null, cell);
            const lastDoesntExistOrIsDifferent = !this.lastHoveredDirection || (this.lastHoveredDirection && this.lastHoveredDirection !== direction);
            if (direction && lastDoesntExistOrIsDifferent) {
                this.showHoveredArrow(direction, cell);
            }
        }
        this.lastHoveredCell = cell;
    }

    /**
     * @description Draws the hovered arrow
     */
    showHoveredArrow(direction, cell) {
        this.lastHoveredDirection = direction;
        cell.update({}, { hover: direction });
        cell.draw();
    }

    /**
     * @description Clears the references
     */
    destroy() {
        this.lastHoveredCell = null;
        this.lastHoveredDirection = null;
    }

    /**
     * @description resets the hovered status over the last hovered cell
     */
    resetHover() {
        if (this.lastHoveredCell) {
            this.lastHoveredCell.update({}, { hover: false });
            this.lastHoveredCell.draw();
        }
        this.lastHoveredCell = this.lastHoveredDirection = null;
    }
}
